import ManageCollocationCenters from 'components/v2/admin/collocation-centers/ManageCollocationCenters';
import React from 'react';
import { Container } from 'styles/Styles.styled';

import { withGreyBackground } from '../../WithGreyBackground';

const CollocationCenters: React.FunctionComponent = () => {
  return (
    <Container>
      <ManageCollocationCenters key={'collocationCenters'} />
    </Container>
  );
};

export default withGreyBackground(CollocationCenters);
